import { view } from '@yola/ws-sdk';
import createCompositeItem from './create-composite-item';
import createCompositeGroup from './create-composite-group';
import calculateNewItemPosition from './calculate-new-item-position';
import getElementSizes from './get-element-sizes';

function addAndConvertToGroup({ elementId }) {
  const staticNode = view.accessors.getStaticElement(elementId);
  const liveNode = view.accessors.getLiveElement(elementId);
  const singleMedia = staticNode.cloneNode(true);
  const slotName = singleMedia.getAttribute('slot') || null;
  const { elementSize, sizeWithInset } = getElementSizes(liveNode);
  const { aspectRatio, width } = elementSize;
  const { width: positioningAreaWidth } = sizeWithInset;
  const mediaGroupId = singleMedia.getAttribute('media-group-id');
  const widthValue = singleMedia.getAttribute('width');

  singleMedia.removeAttribute('slot');
  singleMedia.removeAttribute('width');
  singleMedia.removeAttribute('media-group-id');

  const compositionGroup = createCompositeGroup({
    slot: slotName,
    aspectRatio,
    width: widthValue,
    mediaGroupId,
  });

  const itemWithExistingImage = createCompositeItem({
    childNode: singleMedia,
    position: '50% 50%',
    width: `${((width / positioningAreaWidth) * 100).toFixed(4)}%`,
    aspectRatio,
  });

  compositionGroup.appendChild(itemWithExistingImage);

  const newCompositionItem = createCompositeItem({
    position: calculateNewItemPosition(compositionGroup),
  });

  compositionGroup.appendChild(newCompositionItem);
  view.operations.replaceElement(compositionGroup, elementId);
}

export default addAndConvertToGroup;
